import React, { useRef } from 'react';
import { Chip } from '@milanote/roma';

import { useTranslator } from '../../../components/i18n/useTranslator';
import TaskAssignmentPopupContent from '../../task/pills/assignment/TaskAssignmentPopupContent';
import ChipSelectionPopover from '../selectionViews/ChipSelectionPopover';
import { getChipClassNames } from './elementChipClassNames';
import type { ElementChipProps } from './elementChipTypes';

/**
 * Renders an assignment placeholder pill and its generic selection-owned popover.
 */
const AssignmentPlaceholderChip: React.FC<Extract<ElementChipProps, { type: 'assignment-placeholder' }>> = ({
    containerId,
    size,
    isSelected,
    isSearchHighlighted,
    onDeselect,
}) => {
    const tagRef = useRef<HTMLSpanElement | null>(null);
    const translate = useTranslator('elements', 'elementTypes.task');
    const popupId = `task-assignment-${containerId}-0`;

    return (
        <>
            <Chip
                ref={tagRef}
                size={size}
                variant="normal"
                className={getChipClassNames(isSelected, Boolean(isSearchHighlighted))}
            >
                {translate('assignment.placeholder')}
            </Chip>
            <ChipSelectionPopover
                triggerRef={tagRef}
                isOpen={isSelected}
                onOpenChange={(isOpen) => !isOpen && onDeselect?.()}
            >
                <TaskAssignmentPopupContent popupId={popupId} elementId={containerId} />
            </ChipSelectionPopover>
        </>
    );
};

export default AssignmentPlaceholderChip;
